import { IconName, IconToken } from '@core/user-interface-legacy';

export type CompanyVerificationRequest = {
  companyAddress: string;
  companyCountryCode: string;
  companyName: string;
  companyTaxNumber: string;
  companyWebsite: string;
  id: string;
  status: CompanyVerificationRequestStatus;
};

export type CompanyVerificationRequestPayload = {
  companyAddress: string;
  companyCountryCode: string;
  companyName: string;
  companyTaxNumber: string;
  companyWebsite: string;
};

export type CompanyVerificationResult = { success: boolean; errors?: string[] };

export enum CompanyVerificationRequestStatus {
  Pending = 'pending',
  FormSubmitted = 'form_submitted',
  Approved = 'approved',
  Rejected = 'rejected',
}

export type CompanyVerificationStatusIcon = {
  iconName: IconName;
  iconColor: IconToken;
};
